/* Video */
'use strict';

(function ($, Drupal, once) {
  Drupal.behaviors.StickyBhaviour = {
    attach: function () {
      $(once('StickyBhaviour', '.sticky-navigation')).each(function () {
        // If just the header.
        var topSpacing = 165;
        // If user is logged in add the spacing for the admin menu.
        if ($('body').hasClass('user-logged-in')) {
          topSpacing = 240;
        }

        $(this).sticky({topSpacing: topSpacing, zIndex: 1000});
      });
    }
  };
})(jQuery, Drupal, once);
